import Alert from '@mui/material/Alert';
import type { ReactElement, ReactNode } from 'react';

// role=status, not MUI's default alert: this warning comes and goes with the data, and an
// assertive announcement at each change would drown the screen reader.
const STATUS_ROLE = 'status';

/**
 * Amber warning banner of Home, announced politely: half the daily loss reached (M1 R9). Colours
 * from the mockup palette (`theme.fx.warningBg`, `warningText`). The failed-refresh banner of M7
 * draws the same Alert inside `src/components/FreshnessIndicator.tsx` (Home and Positions share it).
 */
export function WarningNotice({ children }: { readonly children: ReactNode }): ReactElement {
  return (
    <Alert
      severity="warning"
      role={STATUS_ROLE}
      sx={(theme) => ({ bgcolor: theme.fx.warningBg, color: theme.fx.warningText })}
    >
      {children}
    </Alert>
  );
}
